import React from "react";
import { useDispatch } from "react-redux";
import { UPDATE_FIXED_TSL } from "../../../../actions/create-bot-type";
import { isLong } from "../../../../utils/Utils";

const FixedTSL = (props) => {
  const { newBot } = props;
  const tsl = newBot.fixedTSL;
  const long  = isLong(newBot.strategy)
  const dispatch = useDispatch();
  if (!tsl) {
    updateTrailingSL({ triggerAt: 2, stopAt: 1 });
  }
  const updateTrailingSL = (tsl) => {
    dispatch({
      type: UPDATE_FIXED_TSL,
      payload: tsl,
    });
  };
  const trailing = tsl || { triggerAt: 2, stopAt: 1 };
  const changeStopAt = (val) => {
    updateTrailingSL({
      triggerAt: trailing.triggerAt,
      stopAt: val,
    });
  };
  const changeTriggerAt = (val) => {
    updateTrailingSL({
      triggerAt: val,
      stopAt: trailing.stopAt,
    });
  };
  return (
    <div>
      <div className="trailing-item">
        Set{" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={trailing.stopAt}
          onChange={(e) => changeStopAt(e.target.value)}
          min={0}
        />
        % {long?"below":"above"} current price at every{" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={trailing.triggerAt}
          onChange={(e) => changeTriggerAt(e.target.value)}
          min={0}
        />
        % {long?"above":"below"} {long?"Buy":"SellL"} Price
      </div>
    </div>
  );
};

export default FixedTSL;
